// @flow

import { Link } from '@atlassian/amkt-common';
import { LinkUtils } from '@atlassian/mpac-utils';
import React from 'react';

import LargeHeaderContent from './LargeHeaderContent';
import SmallHeaderContent from './SmallHeaderContent';
import {
  AtlassianHeaderLogo,
  AtlassianHeaderLogoImage,
  DesktopWrapper,
  MobileWrapper,
  TabletWrapper,
  TextSearchContainer,
  WrappedLogoMenu,
} from './styles';

import type { BrowserHistory } from 'history/createBrowserHistory';
import type { Map } from 'immutable';
import type { Node } from 'react';

import MarketplaceLogo from './images/MarketplaceLogo.svg';

const setWindowLocation = (location: string) => {
  window.location = location;
};

type HeaderContentType = {
  getUserData: () => void,
  onLogout: () => void,
  userData: Map,
  children?: Node,
  history: BrowserHistory,
};

const HeaderContent = ({
  getUserData,
  onLogout,
  userData,
  children,
  history,
}: HeaderContentType) => {
  React.useEffect(() => {
    getUserData();
  }, []);

  const user = userData.getIn(['data', '_embedded', 'user']);
  const username = user?.get('name');
  const userAvatarUrl = user?.getIn(['_links', 'picture', 'href']);
  const userDataValue = userData.get('data');
  const userEmail = user?.get('email');
  const userLoggedIn = !!user;

  const onLogin = e => {
    LinkUtils.maybeOpenInNewTab(e, () => {
      if (!userData.get('loading')) {
        setWindowLocation(
          userData.getIn(['data', '_links', 'login', 'href']) +
            `?redirect=${window.location.pathname}${encodeURIComponent(window.location.search)}`
        );
      }
    });
  };

  const onClickLogout = () => {
    onLogout();
    return true;
  };

  const onClickLogo = e => {
    if (history) {
      LinkUtils.maybeOpenInNewTab(e, () => {
        history.push({ pathname: '/' });
      });
    }
  };

  const headerTextSearch = <TextSearchContainer>{children}</TextSearchContainer>;

  const headerLogo = (
    <AtlassianHeaderLogo>
      <Link onClick={onClickLogo} title="Atlassian Marketplace" href="/">
        <AtlassianHeaderLogoImage
          src={MarketplaceLogo}
          alt="Atlassian Marketplace Logo"
          id="site-header-logo"
        />
      </Link>
    </AtlassianHeaderLogo>
  );

  const largerHeader = (
    <LargeHeaderContent
      onClickLogin={onLogin}
      onClickLogout={onClickLogout}
      userAvatarUrl={userAvatarUrl}
      userData={userDataValue}
      username={username}
      userLoggedIn={userLoggedIn}
      userEmail={userEmail}
    />
  );
  const smallHeader = (
    <SmallHeaderContent
      onClickLogin={onLogin}
      onClickLogout={onClickLogout}
      userAvatarUrl={userAvatarUrl}
      userData={userDataValue}
      username={username}
      userLoggedIn={userLoggedIn}
      userEmail={userEmail}
    />
  );
  return (
    <>
      <MobileWrapper>
        <WrappedLogoMenu>
          {headerLogo}
          {smallHeader}
        </WrappedLogoMenu>
        {headerTextSearch}
      </MobileWrapper>
      <TabletWrapper>
        <WrappedLogoMenu>
          {headerLogo}
          {largerHeader}
        </WrappedLogoMenu>
        {headerTextSearch}
      </TabletWrapper>
      <DesktopWrapper>
        {headerLogo}
        {headerTextSearch}
        {largerHeader}
      </DesktopWrapper>
    </>
  );
};

export default HeaderContent;
